import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ContactInfo } from './contactInfo';

@JsonObject('model.customer.Customer')
export class Customer extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'qbId')
    qbId?: string;

    @JsonProperty(String, 'qbDisplayName')
    qbDisplayName?: string;

    @JsonProperty(String, 'address')
    address?: string;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'notes')
    notes?: string;

    @JsonProperty([ContactInfo], 'contacts')
    contacts?: ContactInfo[];

    @JsonProperty(String, 'billingName')
    billingName?: string;

    @JsonProperty(ContactInfo, 'billingInfoContact')
    billingInfoContact?: ContactInfo;

    @JsonProperty(String, 'website')
    website?: string;

    @JsonProperty(Boolean, 'active')
    active?: boolean;

    @JsonProperty(Boolean, 'isWholesaler')
    isWholesaler?: boolean;
}
